export default "__VITE_ASSET__cI58DDRk__"